module.exports = __webpack_public_path__ + "static/media/cy-lab-emoji.bf3d67c0.png";